//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTab', srsngTab);

    function srsngTab() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/tabs/tab.html',
            require: '^srsngTabset',
            transclude: true,
            scope: {
                title: '@'
            },
            controller: function ($scope) {
                // this is intentional override
            },
            link: link
        };

        function link(scope, element, attrs, tabsetCtrl) {
            tabsetCtrl.addTab(scope);
        }
    }

})();
